// extracted by mini-css-extract-plugin
export default {"vm":"FamilyMemberGroup_vm__emKwo"};